export default {"src":"/_next/static/media/icon-subscription.1a686848.svg","height":16,"width":16};